import clsx from 'clsx';
import { usePropertyField } from '@vibesites/runtime/react';
import { parseHexColor } from '../hooks/useColor4';

interface AccentBarProps {
  /** Spacing classes plus the fallback colour used when Color 5 is unset. */
  className?: string;
}

/** Decorative bar under section titles, painted in the property's Color 5. */
export function AccentBar({ className }: AccentBarProps) {
  const rgb = parseHexColor(usePropertyField('property_color_5'));
  const color = rgb ? `rgb(${rgb.join(' ')})` : null;

  return (
    <div
      aria-hidden="true"
      className={clsx('w-16 h-1 mx-auto rounded-full', className)}
      style={color ? { background: color, opacity: 1 } : undefined}
    />
  );
}
